import { FirstSection } from "./FirstSection/FirstSection";
import { Navegadores } from "./Navegadores/Navegadores";
import { Timeline } from "./Timeline/Timeline";


export const Home = () => { 
    return(
        <> 
           <FirstSection />
           <Timeline />
           <Navegadores />
        </>
    )
}


